import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Page } from '@zocdoc/components/src/Layout';
import { Metrics, MetricsProvider } from '@zocdoc/frontend-metrics';

import CareersPanel from './CareersPanel';
import { CrazyEgg } from '../../Shared/CrazyEgg';
import FindDoctorsPanel from './FindDoctorsPanel';
import Footer from './Footer';
import GetAppPanel from './GetAppPanel';
import JoinPartnersPanel from './JoinPartnersPanel';
import ListPracticePanel from './ListPracticePanel';
import SearchPanel from './SearchPanel';
import {
    PCE_SUBWAY_HOMEPAGE,
    PCE_TRACKING_ID_DUMMY,
    PINA_PWA_MOBILE_WEB_UPCOMING_APPOINTMENTS_MENU,
    VARIANT_ON,
} from '../../config/ab/experiments';
import withAB from '../../config/ab/withAB';
import { CRAZY_EGG_IDENTIFIERS } from '../../constants';
import JanuaryWellness from './JanuaryWellness';

class HomePage extends PureComponent {
    static propTypes = {
        pageId: PropTypes.string,
        showUpcomingAppointmentsOnMobileMenu: PropTypes.bool,
    };

    render() {
        const subwayHomePageVariation = this.props.ab[PCE_SUBWAY_HOMEPAGE.experimentId];
        const { showUpcomingAppointmentsOnMobileMenu } = this.props;
        return (
            <MetricsProvider getPageId={this.getPageId}>
                <Metrics
                    businessUnit="PatientWebApp"
                    category="Homepage"
                    page="Home"
                    zlogPageType="Homepage"
                    zlogRollupBucket="HomePage"
                >
                    <Page data-test="zd-home-page">
                        <SearchPanel
                            referrerPageType="home"
                            showUpcomingAppointmentsOnMobileMenu={showUpcomingAppointmentsOnMobileMenu}
                            subwayHomePageVariation={subwayHomePageVariation}
                        />
                        {
                            /* NOTE: ThemesSearch has moved inside the JanuaryWellness
                            view due to logic reasons. It did not dissappear. */
                        }
                        <JanuaryWellness
                            subwayHomePageVariation={subwayHomePageVariation}
                        />
                        <GetAppPanel />
                        <ListPracticePanel />
                        <JoinPartnersPanel />
                        <FindDoctorsPanel />
                        <CareersPanel />
                        <Footer />
                        <CrazyEgg
                            DesktopSnapshotName={CRAZY_EGG_IDENTIFIERS.ThemedSearch}
                            MobileSnapshotName={CRAZY_EGG_IDENTIFIERS.ThemedSearch}
                            TabletSnapshotName={CRAZY_EGG_IDENTIFIERS.ThemedSearch}
                        />
                    </Page>
                </Metrics>
            </MetricsProvider>
        );
    }

    getPageId = () => this.props.pageId
}

const AB_FLAGS = [PCE_TRACKING_ID_DUMMY, PINA_PWA_MOBILE_WEB_UPCOMING_APPOINTMENTS_MENU, PCE_SUBWAY_HOMEPAGE];
const mapAbToProps = ab => {
    return {
        showUpcomingAppointmentsOnMobileMenu:
            ab[PINA_PWA_MOBILE_WEB_UPCOMING_APPOINTMENTS_MENU.experimentId] === VARIANT_ON,
    };
};

export default withAB(AB_FLAGS, mapAbToProps)(HomePage);
